<template>
  <div class="flex items-start justify-between gap-2 min-w-0">
    <div class="min-w-0 flex-1">
      <div class="text-[10px] uppercase tracking-wide text-slate-400 leading-none mb-0.5">{{ label }}</div>
      <div
        class="text-sm text-slate-800 break-all leading-snug"
        :class="{ 'font-mono text-xs': mono }"
        :title="value"
      >
        {{ value }}
      </div>
    </div>
    <button
      v-if="hasValue"
      type="button"
      class="shrink-0 mt-0.5 w-7 h-7 rounded border border-slate-200 bg-slate-50 text-slate-500 hover:text-slate-800 hover:bg-slate-100 transition-colors"
      :class="copied ? 'text-green-600 border-green-200 bg-green-50' : ''"
      :title="copied ? 'Copied' : `Copy ${label.toLowerCase()}`"
      @click="copy"
    >
      <i class="pi text-xs" :class="copied ? 'pi-check' : 'pi-copy'"></i>
    </button>
  </div>
</template>

<script>
export default {
  name: 'CopyLine',
  props: {
    label: { type: String, required: true },
    value: { type: String, default: '' },
    mono: { type: Boolean, default: false },
  },
  data() {
    return {
      copied: false,
      copyTimeout: null,
    };
  },
  computed: {
    hasValue() {
      const v = this.value == null ? '' : String(this.value).trim();
      return v.length > 0 && v !== '—';
    },
  },
  beforeUnmount() {
    if (this.copyTimeout) clearTimeout(this.copyTimeout);
  },
  methods: {
    async copy() {
      if (!this.hasValue) return;
      const text = String(this.value);
      try {
        if (navigator?.clipboard?.writeText) {
          await navigator.clipboard.writeText(text);
        } else {
          const el = document.createElement('textarea');
          el.value = text;
          el.setAttribute('readonly', '');
          el.style.position = 'absolute';
          el.style.left = '-9999px';
          document.body.appendChild(el);
          el.select();
          document.execCommand('copy');
          document.body.removeChild(el);
        }
        this.copied = true;
        if (this.copyTimeout) clearTimeout(this.copyTimeout);
        this.copyTimeout = setTimeout(() => {
          this.copied = false;
          this.copyTimeout = null;
        }, 900);
      } catch (e) {
        // silent
      }
    },
  },
};
</script>
